import { useDownloadCustomerMaterialExcelMutation } from "@saleor/graphql/hooks.generated";
import { FormikProps } from "formik/dist/types";

interface Props {
  formik: FormikProps<any>;
  setOpenWarningDialog: React.Dispatch<React.SetStateAction<boolean>>;
  openWarningDialog: boolean;
}

function useDownloadExcel({
  formik,
  setOpenWarningDialog,
  openWarningDialog
}: Props) {
  const [downloadExcel] = useDownloadCustomerMaterialExcelMutation({
    onCompleted: dataExcel => {
      if (dataExcel?.downloadCustomerMaterialExcel?.success) {
        onDownloadExcel(dataExcel);
      } else if (dataExcel?.downloadCustomerMaterialExcel?.errorMessage) {
        setOpenWarningDialog(true);
      }
    }
  });
  const onDownloadExcel = dataExcel => {
    const anchor_href =
      "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
      dataExcel?.downloadCustomerMaterialExcel?.exportedFileBase64;
    const exportLinkElement = document.createElement("a");

    exportLinkElement.hidden = true;
    exportLinkElement.download =
      dataExcel?.downloadCustomerMaterialExcel?.fileName + ".xlsx";
    exportLinkElement.href = anchor_href;
    exportLinkElement.target = "_self";
    document.body.appendChild(exportLinkElement);
    exportLinkElement.click();
    exportLinkElement.remove();
  };
  const downloadExcelFile = () => {
    downloadExcel({
      variables: {
        soldToCode: formik?.values?.soldTo,
        saleOrganizationId: formik?.values?.saleOrganization,
        distributionChannelId: formik?.values?.distributionChannel
      }
    });
  };

  return {
    downloadExcelFile,
    openWarningDialog
  };
}

export default useDownloadExcel;
